module.exports = __webpack_public_path__ + "img/168.eaf67b0b.jpg";